import { Label } from "semantic-ui-react";
import OrderStatusHistory from "../types/entities/OrderStatusHistory";
import User from "../types/entities/User";
import { LOCAL_TOKEN, LOCAL_USER, ORDERS_STATUSES } from "./constants";
import Address from "../types/entities/Address";

export const getLocalToken = () => {
    return localStorage.getItem(LOCAL_TOKEN);
};

export const removeLocalToken = () => {
    localStorage.removeItem(LOCAL_TOKEN);
};

export const setLocalToken = (token: string) => {
    localStorage.setItem(LOCAL_TOKEN, token);
};

export const getLocalUser = () => {
    const user = localStorage.getItem(LOCAL_USER);
    return user ? JSON.parse(user) : null;
};

export const removeLocalUser = () => {
    localStorage.removeItem(LOCAL_USER);
};

export const setLocalUser = (user: User) => {
    localStorage.setItem(LOCAL_USER, JSON.stringify(user));
};

export const handleServiceError = (error: any) => {
    if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (error.response.status === 401) {
            removeLocalToken();
            removeLocalUser();
            window.location.href = "/login";
        }
        throw new Error(error?.response?.data?.detail);
    } else {
        throw new Error(error?.message ?? "Ha ocurrido un error inesperado.");
    }
};

export const getCurrentOrderStatusLabel = (statusHistory: OrderStatusHistory[]) => {
    if (!statusHistory || statusHistory.length === 0) {
        return <Label>Estatus invalido</Label>;
    }
    const currentStatus = statusHistory.find((status) => status.endDate === null);
    if (!currentStatus) {
        return <Label>Sin estatus</Label>;
    }
    if (!ORDERS_STATUSES[currentStatus.status]) {
        return <Label>{currentStatus.status}</Label>;
    }
    return <Label color={ORDERS_STATUSES[currentStatus.status].color}>{ORDERS_STATUSES[currentStatus.status].name}</Label>;
};

export const getOrderStatusName = (status: string) => {
    if (!status) {
        return "Pedido incompleto";
    }
    return ORDERS_STATUSES[status].name;
};

export const getOrderStatusColor = (status: string) => {
    if (!status) {
        return "grey";
    }
    return ORDERS_STATUSES[status].color;
};

export const getCurrentStatus = (statusHistory: OrderStatusHistory[] | undefined) => {
    if (!statusHistory || statusHistory.length === 0) {
        return null;
    }
    const currentStatus = statusHistory.find((status) => status.endDate === null);
    if (!currentStatus) {
        return null;
    }
    return currentStatus.status;
};

export const getStatusDetailsByStatus = (statusHistory: OrderStatusHistory[] | undefined, status: string) => {
    if (!statusHistory || !status) {
        return null;
    }
    const selectedStatus = statusHistory.find((statusHistory) => statusHistory.status === status);
    if (!selectedStatus) {
        return null;
    }
    return selectedStatus;
};

export const formatAddress = (address: Address | null) => {
    if (!address) return "";
    return `${address?.street} ${address?.exteriorNumber} ${address?.interiorNumber}, ${address?.neighborhood}, ${address?.city}, ${address?.state}, Cp. ${address?.postalCode}`;
};